import serverCall from "../../serverCall";

const getAllCountryCode = async (search, page, limit) => {
  const response = await serverCall.get(
    `/country-details/find-all/admin?search=${search}&page=${
      page === undefined ? 1 : page
    }&limit=${limit}`
  );
  return response;
};
const getAllCountry = async (search, page, limit) => {
  const response = await serverCall.get(`/country-details/find-all/admin`);
  return response;
};

const AddCountryCode = async (name, code, data) => {
  const decodedName = encodeURIComponent(name);
  const response = await serverCall.post(
    `/country-details/create/admin?countryName=${decodedName}&countryCode=${code}`,
    data
  );
  return response;
};
const UpdateCountryCode = async (id, name, code, data) => {
  const decodedName = encodeURIComponent(name);
  const response = await serverCall.put(
    `/country-details/update/admin?id=${id}&countryName=${decodedName}&countryCode=${code}`,
    data
  );
  return response;
};
const CountryCodeDelete = async (id) => {
  const response = await serverCall.delete(
    `/country-details/delete/admin?countryId=${id}`
  );
  return response;
};
const GetCountryCode = async (id) => {
  const response = await serverCall.get(
    `/country-details/find-one/admin?countryId=${id}`
  );
  return response;
};

const CountryCodeService = {
  AddCountryCode,
  UpdateCountryCode,
  getAllCountryCode,
  GetCountryCode,
  CountryCodeDelete,
  getAllCountry,
};

export default CountryCodeService;
